
















































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import InputNyeri from "@/components/nyeri/InputNyeri.vue";
import Lokasi from "@/components/pemeriksaan/assesmen/Lokasi.vue";
import Durasi from "@/components/pemeriksaan/assesmen/Durasi.vue";
import Frekuensi from "@/components/pemeriksaan/assesmen/Frekuensi.vue";
import Pencetus from "@/components/pemeriksaan/assesmen/Pencetus.vue";
import KualitasNyeri from "@/components/pemeriksaan/assesmen/KualitasNyeri.vue";
import PolaSerangan from "@/components/pemeriksaan/assesmen/PolaSerangan.vue";
import PenyebabNyeriHilang from "@/components/pemeriksaan/assesmen/PenyebabNyeriHilang.vue";
import JenisNyeri from "@/components/pemeriksaan/assesmen/JenisNyeri.vue";
import { Nyeri } from "@/types/asesmen";

@Component({
  components: {
    InputNyeri,
    Lokasi,
    Durasi,
    Frekuensi,
    Pencetus,
    KualitasNyeri,
    PolaSerangan,
    PenyebabNyeriHilang,
    JenisNyeri
  }
})
export default class AsesmenNyeri extends Vue {
  @Prop() readonly value: Nyeri;

  nyeriSkala = 0;
  nyeri: Nyeri = {
    skala: 0,
    lokasi: null,
    durasi: null,
    frekuensi: null,
    pencetus: null,
    kualitas: null,
    pola_serangan: null,
    penyebab_hilang: null,
    jenis: 1
  };

  get showDetail() {
    return this.nyeri.skala > 0;
  }

  setSkalaNyeri(val) {
    this.nyeri.skala = val;
  }
  setLokasi(val) {
    this.nyeri.lokasi = val;
  }
  setDurasi(val) {
    this.nyeri.durasi = val;
  }
  setFrekuensi(val) {
    this.nyeri.frekuensi = val;
  }
  setPencetus(val) {
    this.nyeri.pencetus = val;
  }
  setKualitasNyeri(val) {
    this.nyeri.kualitas = val;
  }
  setPolaSerangan(val) {
    this.nyeri.pola_serangan = val;
  }
  setPenyebabNyeriHilang(val) {
    this.nyeri.penyebab_hilang = val;
  }
  setJenisNyeri(val) {
    this.nyeri.jenis = val;
  }

  @Watch("nyeri", { deep: true })
  changeNyeri(val: Nyeri) {
    this.$emit("setNyeri", val);
  }

  @Watch("value", { deep: true })
  changeValue(val: Nyeri) {
    this.nyeri = val;
  }
}
